// extracted by mini-css-extract-plugin
export var combinationsDiagram = "biochip-mam-module--combinations-diagram--+7J0j";
export var combination1And2Description = "biochip-mam-module--combination-1-and-2-description--WQt3Q";
export var combination2Additional = "biochip-mam-module--combination-2-additional--Syt4A";
export var combination2Arrow = "biochip-mam-module--combination-2-arrow--YpF4L";
export var combination2AdditionalDescription = "biochip-mam-module--combination-2-additional-description--0O37r";
export var combination3Description = "biochip-mam-module--combination-3-description--fbWaM";